// src/utils/platform.js
// Safe platform + device detection for both web and Capacitor contexts

// ---- iOS check (Capacitor + browser) ----
export const isIOS =
  (typeof window !== "undefined" &&
    /iPad|iPhone|iPod/.test(navigator.userAgent)) ||
  (typeof window !== "undefined" &&
    window?.Capacitor?.getPlatform?.() === "ios");

// ---- General mobile check ----
export const isMobile =
  typeof window !== "undefined" &&
  (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ) ||
    window?.innerWidth < 768 ||
    (window?.Capacitor &&
      ["ios", "android"].includes(window.Capacitor.getPlatform?.())));

